import PropTypes from 'prop-types'
import useMedia from 'hooks/useMedia'

const MediaCompMatch = ({ query = '(max-width: 860px)', matchComponent, noMatchComponent }) => {
  const { matches } = useMedia(query)
  return matches ? matchComponent : noMatchComponent
}

MediaCompMatch.propTypes = {
  query: PropTypes.string,
  matchComponent: PropTypes.object,
}

export default MediaCompMatch
